import { Mock } from './mock';
import * as Purs from './purs-equine-api.js';
export const debug = () => Purs.main(); // exported for testing
////////////////////////////////////////////////////////////////
// Wallet
////////////////////////////////////////////////////////////////
export const isEnabled = async (walletApp) => Purs.isEnabled(walletApp)();
export const availableWallets = () => Purs.availableWallets();
export const selectWallet = async (walletApp) => Purs.getWalletInfo(walletApp)();
// WalletId
// When querying the linked wallet, send the WalletApp as the id
// When querying other people's wallet, the bech 32 staking address is used
export const getWalletInfo = async (walletId) => Purs.getWalletInfo(walletId)();
export const authentifyWallet = async (walletApp) => Purs.authentifyWallet(walletApp)();
export const ownStakeAddr = async (walletApp) => Purs.ownStakeAddr(walletApp)();
export const resolveStakingAddr = async (address) => Purs.resolveAddr(address)();
////////////////////////////////////////////////////////////////
// Horses
////////////////////////////////////////////////////////////////
export const getHorses = async (walletId) => Purs.getHorsesByWalletId(walletId)();
export const getHorse = async (asset) => Purs.getHorse(asset)();
////////////////////////////////////////////////////////////////
// Jockeys
////////////////////////////////////////////////////////////////
export const getJockeys = async (walletId) => Purs.getJockeysByWalletId(walletId)();
export const getJockey = async (asset) => Purs.getJockey(asset)();
////////////////////////////////////////////////////////////////
// Skins
////////////////////////////////////////////////////////////////
export const getSkins = async (walletId) => Purs.getSkinsByWalletId(walletId)();
export const getSkin = async (asset) => Purs.getSkin(asset)();
////////////////////////////////////////////////////////////////
// Races
////////////////////////////////////////////////////////////////
export const getRaces = async (filter) => Mock.getRaces(filter);
export const getRaceInfo = async (id) => Mock.getRace(id);
export const activateHorse = async (asset, name) => Mock.delayTrue(asset, name);
export const registerToRace = async (asset, id) => Mock.delayTrue(asset, id);
export const deregisterfromRace = async (asset, id) => Mock.delayTrue(asset, id);
export const scratchFromRace = async (asset, id) => Mock.delayTrue(asset, id);
export const completeRace = async (asset, id) => Mock.completeRace(asset, id);
////////////////////////////////////////////////////////////////
// Races - Admin
////////////////////////////////////////////////////////////////
export const adminCreateRace = async (info) => Mock.adminCreateRace(info);
export const adminUpdateRace = async (info) => Mock.adminCreateRace(info);
export const adminDeleteRace = async (id) => Mock.delayTrue(id);
